/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Typography from "@mui/material/Typography";

import { MenuAnchorEl } from "../../../../../shared";
import Menu from "../../../../Menu/Menu";
import { useStyles } from "../../../styles";

interface NotificationsDesktopProps {
  anchorEl: MenuAnchorEl;
  close: () => void;
}

const NotificationsDesktop = ({
  anchorEl,
  close
}: NotificationsDesktopProps) => {
  const { notificationsDesktopMenu } = useStyles();

  return (
    <Menu
      open={Boolean(anchorEl)}
      onClose={close}
      anchorEl={anchorEl}
      css={css(notificationsDesktopMenu)}
    >
      <Typography variant="body2Medium">Notifications content</Typography>
    </Menu>
  );
};

export default NotificationsDesktop;
